import React, { createContext, useState, useContext } from 'react';
import { useSelector } from "react-redux";

const OtpReportContext = createContext();

export const OtpReportProvider = ({ children }) => {
    const [data, setData] = useState([]);
    const [paginationOptions, setPaginationOptions] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [isFetching, setIsFetching] = useState(false);

    const lang = useSelector((state) => state.constant.languages);

    const [tableFilter, setTableFilter] = useState({
        page: 0,
        rowsPerPage: 25,
        order: "desc",
        orderBy: "registered_at",
        search: "",
        registeredDate: null,
        verifiedDate: null
    });

    const language = useSelector((state) => state.profile.language);

    const page = tableFilter.page;
    const search = tableFilter.search;
    const rowsPerPage = tableFilter.rowsPerPage;

    return (
        <OtpReportContext.Provider value={{
            data,
            setData,
            paginationOptions,
            setPaginationOptions,
            totalRecords,
            setTotalRecords,
            isFetching,
            setIsFetching,
            lang,
            tableFilter,
            setTableFilter,
            language,
            page,
            search,
            rowsPerPage
        }}>
            {children}
        </OtpReportContext.Provider>
    );
};

export const useOtpReport = () => {
    return useContext(OtpReportContext);
};
